import React, { useEffect, useState } from "react";
import { LoggedInView } from "../common/LoggedInView";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { getSettings, updateSettings } from "../../store/reducers/SettingsSlice";
import { UpdateSetting } from "../../models/Setting";
import Editor from 'react-simple-wysiwyg';
import SettingsCountryPicker from "../common/SettingsCountryPicker";
import { RequestStatus } from "../../utils/Enums";

interface SettingsScreenProps {}

export const SettingsScreen: React.FC<SettingsScreenProps> = () => {
    const dispatch = useAppDispatch();
    const settingsState = useAppSelector(state => state.settings);
    const [updatedSettings, setUpdatedSettings] = useState<UpdateSetting[]>([]);
    const [updated, setUpdated] = useState(false);

    useEffect(() => {
        dispatch(getSettings());
    }, [dispatch]);

    const handleInputChange = (identifier: string, value: string) => {
        const index = updatedSettings.findIndex((setting) => setting.identifier === identifier);
        const setting = settingsState.settings.find(s => s.identifier === identifier);

        if (index !== -1) {
            const updatedSettingsCopy = [...updatedSettings];
            updatedSettingsCopy[index] = { identifier, value, type: setting?.type || 'text' };
            setUpdatedSettings(updatedSettingsCopy);
        } else {
            setUpdatedSettings([...updatedSettings, {
                identifier,
                value,
                type: setting?.type || 'text'
            }]);
        }
    };

    const handleCountryChange = (identifier: string, countryIds: number[]) => {
        handleInputChange(identifier, JSON.stringify(countryIds));
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        dispatch(updateSettings(updatedSettings));
        setUpdated(true);
    };

    return (
        <LoggedInView fullWidth={false}>
            {updated && (
                <div className="message msg-ok">
                    <div>
                        <h2>Seaded uuendatud</h2>
                    </div>
                </div>
            )}
            <div className="form">
                <h2><span>Seaded</span></h2>
                <table className="form">
                    <tbody>
                    {settingsState?.settings.map(setting => (
                        <tr key={setting.identifier}>
                            <th>{setting.name}:</th>
                            <td>
                                {setting.type === 'wysiwyg' ? (
                                    <Editor
                                        value={updatedSettings.find((s) => s.identifier === setting.identifier)?.value || setting.value}
                                        onChange={(e) => handleInputChange(setting.identifier, e.target.value)}
                                    />
                                ) : setting.type === 'countryPicker' ? (
                                    <SettingsCountryPicker
                                        value={JSON.parse(updatedSettings.find((s) => s.identifier === setting.identifier)?.value || setting.value || '[]')}
                                        onChange={(countryIds) => handleCountryChange(setting.identifier, countryIds)}
                                    />
                                ) : (
                                    <input
                                        type="text"
                                        name={setting.identifier}
                                        className="text"
                                        value={updatedSettings.find((s) => s.identifier === setting.identifier)?.value || setting.value}
                                        onChange={(e) => handleInputChange(setting.identifier, e.target.value)}
                                    />
                                )}
                            </td>
                        </tr>
                    ))}
                    <tr>
                        <th></th>
                        <td>
                            <button type="submit" onClick={handleSubmit}>
                                <span><strong>Muuda</strong></span>
                            </button>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            {updated && (
                <div className="message msg-ok">
                    <div>
                        <h2>Seaded uuendatud</h2>
                    </div>
                </div>
            )}
        </LoggedInView>
    );
}